<template>
  <div class="message-push-setting">
    <h1>消息推送渠道设定</h1>
    <div class="block">
      <div class="title">微信公众号</div>
      <div class="con">
        <van-switch v-model="SetPushType.IsUseWeixinPush" @change='save' />
      </div>
    </div>
    <div class="block">
      <div class="title">邮件</div>
      <div class="con">
        <van-switch v-model="SetPushType.IsUseMailPush" @change='save' />
      </div>
    </div>
    <div class="block">
      <div class="title">正雅医生APP</div>
      <div class="con">
        <van-switch v-model="IsUseAppPush" disabled />
      </div>
    </div>
    <h1><span>3D目标位查看及确认</span>
      <van-icon name="question" @click='showPopover=!showPopover' />
    </h1>
    <div class='tip-box' v-if='showPopover'>
      正雅设计动画顺序：3D目标位->3D设计<br />
      3D设计是在3D目标位上制作分步动画，请您根据临床习惯选择是否需要在3D设计前查看或确认3D目标位。<br />
      若需要确认3D目标位，正雅会在确认后，再进行该病例分步动画的制作。<br />
    </div>
    <div class="block">
      <div class="title">查看3D目标位</div>
      <div class="con">
        <van-switch v-model="SetPushType.IsSendAimAnim" @change='changeSendAim' />
      </div>
    </div>
    <div class="block">
      <div class="title">确认3D目标位</div>
      <div class="con">
        <van-switch v-model="SetPushType.IsConfirmAimAnim" @change='changeConfirmAim' />
      </div>
    </div>
    <div class='btn-wrap'>
      <van-button type="default" size="large" @click="backHome">返回首页</van-button>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      showPopover: false,
      IsUseAppPush: true,
      SetPushType: {
        AppID: this.GLOBAL.AppID,
        Method: 'SetPushType',
        UserRegisterID: Cookies.get('uid'),//用户注册ID
        IsUseWeixinPush: false,//是否用微信推送
        IsUseMailPush: false,//是否用邮件推送
        IsSendAimAnim: false,//是否查看目标位（是否发送目标位动画）:true:是,false:否
        IsConfirmAimAnim: false,//是否确认目标位（是否确认目标位动画）:true:是,false:否 
      },
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    changeSendAim (val) {
      if (!val) {
        this.SetPushType.IsConfirmAimAnim = false
      }
      this.save()
    },
    changeConfirmAim (val) {
      if (val) {
        this.SetPushType.IsSendAimAnim = true
      }
      this.save()
    },
    backHome () {
      this.$router.push({ path: '/setting-page', replace: true })
    },
    save () {
      this.$Request(this.SetPushType).then(res => {
        this.$toast("配置已生效")
      })
    },
    getDetail () {
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Method: 'GetUserPushType',
        UserRegisterID: Cookies.get('uid'),//用户编号 
      }).then(res => {
        let { SetPushType } = this
        SetPushType.IsUseWeixinPush = res.IsUseWeixinPush
        SetPushType.IsUseMailPush = res.IsUseMailPush
        SetPushType.IsSendAimAnim = res.IsSendAimAnim
        SetPushType.IsConfirmAimAnim = res.IsConfirmAimAnim
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.van-switch--on {
  background-color: @blue;
}
/deep/.van-button--info {
  background-color: @blue;
  border: 1px solid @blue;
}
.message-push-setting {
  padding: 20px;
  h1 {
    color: @blue;
    font-size: 32px;
    border-left: 4px solid @blue;
    padding-left: 10px;
  }
  .block {
    margin: 10px;
    line-height: 1.5;
    height: 80px;
    .title {
      width: 50%;
      display: inline-block;
      float: left;
    }
    .con {
      width: 50%;
      display: inline-block;
      float: left;
    }
  }
  .btn-wrap {
    width: 100%;
    margin: 10px auto;
    text-align: center;
    .van-button {
      margin-bottom: 20px;
    }
  }
  .tip-box {
    padding: 10px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/member/message-push-setting.vue